import {
    lazyCreateOrUpdateOptionsForFeature,
    OwsOptionsFeatureType,
    MentionEventNotificationsOptions,
    TxpEventNotificationsOptions,
} from 'owa-outlook-service-options';

export async function createOrUpdateMentionEventNotificationsOptions(
    options: MentionEventNotificationsOptions
): Promise<void> {
    await lazyCreateOrUpdateOptionsForFeature
        .importAndExecute(OwsOptionsFeatureType.MentionEventNotifications, options)
        .catch(_ => null);
}

export async function createOrUpdateTxpEventNotificationsOptions(
    options: TxpEventNotificationsOptions
): Promise<void> {
    await lazyCreateOrUpdateOptionsForFeature
        .importAndExecute(OwsOptionsFeatureType.TxpEventNotifications, options)
        .catch(_ => null);
}
